export default function () {
    // Open spreadsheet editor link in the same window if there's already a window with the name baseUrl
    $('.spreadsheet-editor-link').on('click', function () {
        window.open((<HTMLAnchorElement>this).href, $(this).data('editor-base-url'));
        return false;
    });
}